<template>
  <div class="product_edit">
     <el-dialog v-dialogDrag :title="supplement===false?($t('enterprise.enterprise') + '/' + $t('enterprise.search')):$t('mdsrecipient.modelname')" :visible.sync="dialogVisible" v-if="dialogVisible" @close="closeDialog" :close-on-click-modal="false" :append-to-body="true" width="850px">
      <template v-if="supplement===false">
        <!--查找标准（固定一个，不需要选择切换）-->
        <div class="searchStandardFixed" v-if="entOrgFlag1 === '1' || entOrgFlag1 === '2' || entOrgFlag1 === '5'">
          {{ $t('enterprise.standardlookup') }}：{{ entOrgFlag1 === '1' ? $t('enterprise.enterprise') : $t('enterprise.department') }}
        </div>
        <!--查找标准切换-->
        <div class="searchStandard" v-else>
          <div class="standard" :class="{active: isActive}" @click="changeSearchStandard(true)">{{ $t('enterprise.enterprise') }}</div>
          <div class="standard" :class="{active: !isActive}" @click="changeSearchStandard(false)">{{ $t('enterprise.department') }}</div>
        </div>
        <!--查询条件-->
        <el-form :model="searchForm" ref="searchForm" label-width="190px" label-position="left" class="editForm">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item v-if="entOrgFlag1 === '2'" :label="$t('enterprise.name') + ':'" prop="orgName" label-width="150px">
                {{ searchForm.orgName }}
              </el-form-item>
              <div v-else>
                <el-form-item :label="$t('enterprise.name') + ':'" prop="orgName" label-width="150px" style="width: calc(100% - 90px);display: inline-block">
                  <el-input v-model="searchForm.orgName" size="mini" autocomplete="off" style="width: 100%"></el-input>
                </el-form-item>
                <el-select v-model="searchForm.language" size="mini" style="width: 80px;margin-left: 10px;">
                  <el-option v-for="item in languageList" :label="ifZh ? item.name : item.enName" :value="item.value" :key="item.value"></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="(entOrgFlag1 === '2' || entOrgFlag1 === '4' || entOrgFlag1 === '5') ? $t('enterprise.identifierorganization') : $t('enterprise.enterpriseidentifier')" prop="orgId">
                <el-input v-model="searchForm.orgId" name="orgId" size="mini" placeholder="" auto-complete="on" autocomplete="on"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12" v-if="entOrgFlag1 === '2' || entOrgFlag1 === '4' || entOrgFlag1 === '5'">
              <el-form-item :label="$t('enterprise.departmentName') + ':'" prop="orgNameH" label-width="150px">
                <el-input v-model="searchForm.orgNameH" size="mini" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" :offset="(entOrgFlag1 === '2' || entOrgFlag1 === '4' || entOrgFlag1 === '5') ? 0 : 12">
              <el-form-item :label="$t('enterprise.city') + ':'" prop="province">
                <el-input v-model="searchForm.province" size="mini" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('enterprise.user') + ':'" prop="name" label-width="150px">
                <el-input v-model="searchForm.name" size="mini" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('enterprise.DUNScoding') + ':'" prop="duns">
                <el-input v-model="searchForm.duns" size="mini" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('enterprise.useridentifier') + ':'" prop="userId" label-width="150px">
                <el-input v-model="searchForm.loginName" size="mini" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('enterprise.postalcode') + ':'" prop="postCode">
                <el-input v-model="searchForm.postCode" size="mini" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('enterprise.oCode') + ':'" prop="orgCode" label-width="150px">
                <el-input v-model="searchForm.orgCode" size="mini" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('enterprise.country') + ':'" prop="countryId">
                <el-select filterable v-model="searchForm.countryId" style="width:100%" size="mini" @change="$forceUpdate()">
                  <el-option v-for="item in countryList" :key="item.key" :label="ifZh ? item.value : item.enValue" :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="handleButton">
            <el-button type="primary" size="small" @click="search">{{ $t('enterprise.search') }}</el-button>
          </div>
        </el-form>
        <!--查询企业列表-->
        <el-table ref="enterpriseTable" :data="tableData" border style="width: 100%;margin-top: 10px" :height="300" size="mini" :cell-style="{ height: '44px', padding: '3px 0px' }" highlight-current-row @row-click="rowClick">
          <el-table-column align="center" :label="$t('enterprise.number')" type="index" width="60">
            <template slot-scope="scope">
              <span>{{
              scope.$index + (page.pageNo - 1) * page.pageSize + 1
            }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('enterprise.name')" :prop="ifZh ? 'orgName' : 'orgEnName'" min-width="200px" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column v-if="entOrgFlag1 === '2' || entOrgFlag1 === '4' || entOrgFlag1 === '5'" min-width="200px" :label="$t('enterprise.departmentName')" :prop="ifZh ? 'orgNameo' : 'orgEnNameo'" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('enterprise.identifier')" min-width="100px" prop="orgIdo" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('enterprise.city')" prop="province" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('enterprise.postalcode')" min-width="100px" prop="postCode" align="center" show-overflow-tooltip></el-table-column>
        </el-table>
        <pagination v-show="total > 0" :total="total" :page.sync="page.pageNo" :limit.sync="page.pageSize" @pagination="getTableData()" />

        <div class="handleButton" style="margin-top: 10px;">
          <el-button @click="handleView" type="primary" size="small">{{ $t('enterprise.see') }}</el-button><!--查看-->
          <el-button @click="handleApply" type="primary" size="small" v-if="module!=='1'">{{ $t('enterprise.adoption') }}</el-button><!--应用-->
          <el-button @click="handleReturn" type="primary" size="small">{{ $t('enterprise.return') }}</el-button><!--确定-->
          <el-button type="primary" size="small" @click="closeDialog">{{ $t('enterprise.cancel') }}</el-button><!--取消-->
        </div>
      </template>
      <template v-else>
        <el-form :model="addForm" ref="addForm" :disabled="type==='view'" :rules="addFormRules" label-width="180px" label-position="left" class="editForm">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('mdsrecipient.supplierCode')" prop="supplierCode">
                <el-input v-model.trim="addForm.supplierCode"  size="mini" autocomplete="on" maxlength="200"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('mdsrecipient.symbol')" key="symbol" prop="symbol">
                <el-input v-model.trim="addForm.symbol" size="mini" :placeholder="$t('mdsrecipient.symbolPlaceholder')" autocomplete="on" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('mdsrecipient.mdsName')" prop="mdsName">
                <el-input v-model="addForm.mdsName" size="mini" autocomplete="off" maxlength="200"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('mdsrecipient.cfrName')" prop="drawingId">
                <el-input v-model="addForm.cfrName" size="mini" autocomplete="off" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('mdsrecipient.drawingId')" prop="drawingId">
                <el-input v-model="addForm.drawingId" size="mini" autocomplete="off" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('mdsrecipient.drawingDate')" prop="drawingDate">
                <el-date-picker v-model="addForm.drawingDate" size="mini" type="date" value-format="yyyy-MM-dd" placeholder="">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('mdsrecipient.drawingModCode')" prop="drawingModCode">
                <el-input v-model="addForm.drawingModCode" size="mini" autocomplete="off" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('mdsrecipient.reportCode')" prop="reportCode">
                <el-input v-model="addForm.reportCode" size="mini" autocomplete="off" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('mdsrecipient.reportDate')" prop="reportDate">
                <el-date-picker v-model="addForm.reportDate" size="mini" type="date" value-format="yyyy-MM-dd" placeholder="">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('mdsrecipient.purchaseOrderNo')" prop="purchaseOrderNo">
                <el-input v-model="addForm.purchaseOrderNo" size="mini" autocomplete="off" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('mdsrecipient.billOfLading')" prop="billOfLading">
                <el-input v-model="addForm.billOfLading" size="mini" autocomplete="off" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('mdsrecipient.denialReason')" prop="denialReason">
                <el-input v-model="addForm.denialReason" readonly type="textarea" size="mini" autocomplete="off" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('mdsrecipient.forwordAllowed')" prop="forwordAllowed">
                <el-radio-group v-model="addForm.forwordAllowed">
                  <el-radio label="1">{{$t('mdsrecipient.yes')}}</el-radio>
                  <el-radio label="0">{{$t('mdsrecipient.no')}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('mdsrecipient.remark')" prop="remark">
                <el-input v-model="addForm.remark" type="textarea" size="mini" autocomplete="off" maxlength="50"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="handleButton">
          <el-button @click="handleReturn2" v-if="type!=='view'" type="primary" size="mini">{{ $t('enterprise.return') }}</el-button><!--确定-->
          <el-button type="primary" size="small" @click="closeDialog">{{ $t('enterprise.cancel') }}</el-button><!--取消-->
        </div>
      </template>
    </el-dialog>
    <!--企业详细信息弹窗-->
     <el-dialog v-dialogDrag :title="$t('enterprise.detail')" :visible.sync="enterpriseInfoVisible" :append-to-body="true" v-if="enterpriseInfoVisible" :close-on-click-modal="false" width="850px">
      <el-descriptions :title="$t('enterprise.date')" :column="1" border>
        <el-descriptions-item :label="$t('enterprise.DUNScoding')">{{ enterpriseDetail.duns }}</el-descriptions-item>
        <el-descriptions-item :label="$t('enterprise.name')">{{ enterpriseDetail.enterpriseName }}</el-descriptions-item>
        <el-descriptions-item :label="$t('enterprise.departmentName')">{{ enterpriseDetail.orgName }}</el-descriptions-item>
        <el-descriptions-item :label="$t('enterprise.englishName')">{{ enterpriseDetail.orgEname }}</el-descriptions-item>
        <el-descriptions-item :label="$t('enterprise.foreignLanguage')">{{ enterpriseDetail.orgFname }}</el-descriptions-item>
        <el-descriptions-item :label="$t('enterprise.country')">{{ enterpriseDetail.countryName }}</el-descriptions-item>
        <el-descriptions-item :label="$t('enterprise.city')">{{ enterpriseDetail.province }}</el-descriptions-item>
        <el-descriptions-item :label="$t('enterprise.postalcode')">{{ enterpriseDetail.postCode }}</el-descriptions-item>
        <el-descriptions-item :label="$t('enterprise.post')">{{ enterpriseDetail.address }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { getCountryList } from "@/api/platformAdmin/departmentManage";
import { getIe8n } from "@/utils/auth";
import { getEnterpriseViewList, findEnterpreseInfoViewByOrgId } from "@/api/platformAdmin/entorguser";

export default {
  name: "enterpriseSearch",
  props: {
    entOrgFlag: { //不同情景下调用传不同参数
      type: String,
      default: '0'
    },
    mdsName: {
      type: String,
      default: ''
    },
    sendMdsId: {
      type: String,
      default: ''
    },
    orgName: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    module: { //module为1时，不显示’应用‘按钮
      type: String,
      default: ''
    },
    sendFlag: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'create'
    },
    row: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      searchForm: {
        orgName: '',
        orgNameH: '',
        language: 'CN'
      },
      searchFormCopy: {},
      isActive: true,
      countryList: [],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      ifZh: true,
      supplement: false,
      currentRow: null,
      enterpriseInfoVisible: false,
      enterpriseDetail: null,
      addForm: {
        forwordAllowed: '1'
      },
      addFormRules: {
        supplierCode: [
          { required: true, message: this.$t('mdsrecipient.errorMessage6'), trigger: 'blur' }
        ],
        symbol: [
          { required: true, message: this.$t('mdsrecipient.errorMessage7'), trigger: 'blur' }
        ],
        mdsName: [
          { required: true, message: this.$t('mdsrecipient.errorMessage8'), trigger: 'blur' }
        ],
      },
      languageList: [
        { name: '中文', enName: 'Chinese', value: 'CN' },
        { name: '英文', enName: 'English', value: 'EN' },
        { name: '外文', enName: 'Foreign', value: 'FR' },
      ],
      entOrgFlag1: ''
    }
  },
  mounted() {
    if (this.type === 'edit' || this.type === 'view') {
      this.supplement = true;
      this.addForm = this.$clone(this.row);
    }
    //初始赋值企业名称（非输入框）
    if (this.orgName) {
      this.searchForm.orgName = this.orgName;
    }
    //清空企业名称输入框
    if (this.entOrgFlag !== '2') {
      this.searchForm.orgName = '';
    } else {
      this.searchForm.enterpriseId = this.$store.state.user.enpid;
    }
    this.dialogVisible = this.visible;
    this.searchForm.entOrgFlag = this.entOrgFlag;
    this.entOrgFlag1 = this.entOrgFlag;
    this.ifZh = getIe8n() === "zh";
    getCountryList(["查询国家列表"]).then(res => {
      this.countryList = [{ key: 'ALL', value: '所有国家', enValue: 'ALL' }, ...res.data];
      this.searchForm.countryId = 'ALL';
    })
  },
  methods: {
    getIe8n,
    //企业/部门切换
    changeSearchStandard(flag) {
      this.isActive = flag;
      if (flag) {
        this.searchForm.entOrgFlag = '3';
        this.entOrgFlag1 = '3';
        this.searchForm.orgNameH = '';
      } else {
        this.searchForm.entOrgFlag = '4';
        this.entOrgFlag1 = '4';
      }
    },
    //查找 条件搜索
    search() {
      // 必须有一个查询条件
      if (this.$empty(this.searchForm.orgName)
        && this.$empty(this.searchForm.orgId)
        && this.$empty(this.searchForm.orgNameH)
        && this.$empty(this.searchForm.province)
        && this.$empty(this.searchForm.name)
        && this.$empty(this.searchForm.duns)
        && this.$empty(this.searchForm.loginName)
        && this.$empty(this.searchForm.postCode)
        && this.$empty(this.searchForm.orgCode)) {
        return this.$message.warning(this.$t('enterprise.one'))
      }
      this.page.pageNo = 1;
      this.searchFormCopy = this.$clone(this.searchForm);
      // 关键：触发原生 form 提交（即使action是#，浏览器也会记录历史）
      this.getTableData();
    },
    // 列表表格加载
    getTableData() {
      let param = this.page;
      if (this.searchFormCopy) {
        param = JSON.parse(JSON.stringify(Object.assign(this.searchFormCopy, this.page)));
      }
      getEnterpriseViewList(param, ["企业部门列表查询", JSON.stringify(param)]).then(({ data }) => {
        this.tableData = data ? data.records : [];
        this.total = data ? data.total : 0;
        if (this.tableData.length > 0) {
          this.$refs.enterpriseTable.setCurrentRow(this.tableData[0])
          this.currentRow = this.tableData[0];
        }
      });
    },
    //关闭回调
    closeDialog() {
      this.$emit('close')
    },
    //点击行事件
    rowClick(row, column, event) {
      this.currentRow = row;
    },
    //查看
    handleView() {
      if (!this.currentRow) {
        return this.$message.warning(this.$t('enterprise.mustSelect'))
      }
      findEnterpreseInfoViewByOrgId(this.currentRow.orgIdo, ['根据ID查询企业详情']).then(res => {
        this.enterpriseDetail = res.data;
        this.enterpriseInfoVisible = true;
      })
    },
    //应用(弹窗不关闭)
    handleApply() {
      if (!this.currentRow) {
        return this.$message.warning(this.$t('enterprise.mustSelect'))
      }
      this.$emit('addEntOrg', this.currentRow, 'noClose');
    },
    //确定(弹窗关闭)
    handleReturn() {
      if (!this.currentRow) {
        return this.$message.warning(this.$t('enterprise.mustSelect'))
      }
      if (this.sendFlag === true) {
        this.supplement = true;
        this.addForm = {
          ...this.addForm,
          recEntId: this.currentRow.orgId,
          recOrgId: this.currentRow.orgIdo,
          sendMdsId: this.sendMdsId,
          sendUserId: this.$store.state.user.usid,
          recEntEname: this.currentRow.orgEnName,
          recEntName: this.currentRow.orgName,
          recOrgName: this.currentRow.orgNameo,
          recOrgEname: this.currentRow.orgEnNameo,
        }
        if (this.addForm.kid) {
          this.addForm.state = 'modified';
        } else {
          this.addForm.state = 'NEW';
        }
        if (!this.addForm.recStatus) {
          this.$set(this.addForm, 'recStatus', 'E')
        }
        if (!this.addForm.mdsName) {
          this.$set(this.addForm, 'mdsName', this.mdsName)
        }
      } else {
        this.$emit('addEntOrg', this.currentRow);
        this.closeDialog();
      }
    },
    handleReturn2() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$emit('addEntOrg', this.addForm);
          this.closeDialog();
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.searchStandardFixed {
  color: #409eff;
}
.el-date-editor {
  width: 100%;
}
.searchStandard {
  display: flex;

  .standard {
    width: 50%;
    text-align: center;
    padding: 5px 0;
    @include background('light-color');
    color: #000;
    cursor: pointer;

    &.active {
      @include background-color;
      color: #ffffff;
    }
  }
}
.editForm {
  margin-top: 10px;
}
.handleButton {
  text-align: right;
}
</style>
